import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ModelAnswer } from '@/domain/entities/modelAnswer/modelAnswer'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { ModelAnswerListModuleName } from '@/store/modules/modules'

export class ModelAnswerListViewModel {
  private store = useStore()

  modelAnswerList: ComputedRef<{ [judgeId: number]: ModelAnswer }> = computed(
    () => this.store.getters[`${ModelAnswerListModuleName}/modelAnswerList`]
  )
  loading: ComputedRef<boolean> = computed(() => this.store.getters[`${ModelAnswerListModuleName}/loading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${ModelAnswerListModuleName}/error`])

  setModelAnswerList(list: { [judgeId: number]: ModelAnswer }): void {
    this.store.commit(`${ModelAnswerListModuleName}/setModelAnswerList`, { list })
  }

  async fetchModelAnswerList(
    problemId: string,
    programLanguage: ProgramLanguageType,
    pageIndex: number
  ): Promise<void> {
    await this.store.dispatch(`${ModelAnswerListModuleName}/fetchModelAnswerList`, {
      problemId,
      programLanguage,
      pageIndex
    })
  }
}
